import { render } from "./StripePaymentForm.vue?vue&type=template&id=564d4fe1&scoped=true"
import script from "./StripePaymentForm.vue?vue&type=script&lang=js"
export * from "./StripePaymentForm.vue?vue&type=script&lang=js"

import "./StripePaymentForm.vue?vue&type=style&index=0&id=564d4fe1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-564d4fe1"]])

export default __exports__